import { sendGAEvent } from '@next/third-parties/google'
import { useState, useEffect } from 'react'

export default function useSleep(stationId: string) {
    const [timer, setTimer] = useState<number>(0)
    const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null)
    const [selected, setSelected] = useState<number | null>(null)

    const cancel = () => {
        if (intervalId) {
            clearInterval(intervalId);
        }
        setTimer(0);
        setSelected(null);
    }

    const set = (duration: number) => {
        const durationInSeconds = duration * 60
        setSelected(duration)
        if (intervalId)
            clearInterval(intervalId)
        setTimer(durationInSeconds)
        const newIntervalId = setInterval(() => {
            setTimer((prev) => {
                if (prev > 0) {
                    return prev - 1
                } else {
                    pauseAudio()
                    clearInterval(newIntervalId)
                    return 0
                }
            })
        }, 1000)
        setIntervalId(newIntervalId)
        sendGAEvent('event', 'sleep', { screen_name: stationId, value: duration })
    }

    const pauseAudio = () => {
        const audioElement = document.querySelector('audio')
        if (audioElement)
            audioElement.pause()
    }

    useEffect(() => {
        return () => {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
    }, [intervalId])

    return {
        set, cancel, timer, selected
    }
}
